import React from "react";
import { DataGridCardProps } from "designSystem/components/dataGrid/DataGrid";
import { Exploration } from "../../types";
import types from "csi/types";
import { Box, Button, CsiImage, FlexColumn, FlexRow, MenuItem, MoreHorizMenu, Text, OverflowText } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { black } from "designSystem/styles/color";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { observer } from "mobx-react-lite";
import ExplorationIcon from "../explorationIcon/ExplorationIcon";

const ExplorationsListItem =  observer(({ item: { id, name, thumbnail, thumbnailIcon, updatedAt, createdAt } }: DataGridCardProps<Exploration>) => {
	const date = types.getFormattedDateDifference(new Date(updatedAt ?? createdAt), false);
	const fashionInspirationStore = useManageFashionInspirationStore();
	const {
		handleOpenExploration,
		handleOpenExplorationPinnedImagesPane,
		handleDeleteExplorationMenuItemClick,
		handleRenameExplorationMenuItemClick,
	} = fashionInspirationStore;

	return (
		<Box
			border={STANDARD_BORDER_STYLE}
			borderRadius={1}
			minHeight={104}
		>
			<FlexRow
				gap={2}
				p={3}
				position="relative"
				width={1}
			>
				<FlexColumn maxWidth={80} minWidth={80}>
					<CsiImage
						aspectRatio={1}
						borderRadius={4}
						noImageComponent={ExplorationIcon({ thumbnailIcon })}
						src={thumbnail}
					/>
				</FlexColumn>
				<FlexColumn
					flexGrow={1}
					justifyContent="space-between"
					overflow="hidden"
					width={1}
				>
					<FlexColumn gap={1} marginRight={4}>
						<OverflowText
							semiBold
							text={name}
							variant="h5"
						/>
						<Text
							color={black[600]}
							text={date}
							variant="body1"
						/>
					</FlexColumn>
					<FlexRow gap={2} justifyContent="flex-end">
						<Button
							design="default"
							onClick={() => handleOpenExplorationPinnedImagesPane(id)}
							res="Pinned"
							sx={{ fontWeight: 590 }}
						/>
						<Button
							design="secondary"
							onClick={() => handleOpenExploration(id)}
							res="Open"
							sx={{ fontWeight: 590 }}
						/>
					</FlexRow>
				</FlexColumn>
				<Box
					position="absolute"
					right={4}
					top={4}
				>
					<MoreHorizMenu>
						<FlexColumn minWidth={166}>
							<MenuItem onClick={() => handleRenameExplorationMenuItemClick(id, name)} res="Rename" />
							<MenuItem onClick={() => handleDeleteExplorationMenuItemClick(id, name)} res="Delete" />
						</FlexColumn>
					</MoreHorizMenu>
				</Box>
			</FlexRow>
		</Box>
	);
});

export  default ExplorationsListItem;
